import makeQuery from "@saleor/hooks/makeQuery";
import gql from "graphql-tag";

import { RecommendPopup } from "./types/RecommendPopup";

export const recommendPopupFragment = gql`
  fragment RecommendPopupFragment on RecommendPopup {
    id
    recommendUrl
    isEnable
    formVoucherText
    formImagePc
    formImageMb
    recommendVoucherText
    recommendImagePc
    recommendImageMb
    emailSubject
    emailContent
    defaultMessage
    facebookMessage
    fromVoucher {
      id
      code
      name
    }
    recommendVoucher {
      id
      code
      name
    }
  }
`;

const recommendPopup = gql`
  ${recommendPopupFragment}
  query RecommendPopup {
    recommendPopup {
      ...RecommendPopupFragment
    }
  }
`;

export const useRecommendPopupQuery = makeQuery<RecommendPopup, null>(
  recommendPopup
);
